import { type GroupCost } from '@entities/schedules/service/types';
import * as yup from 'yup';

export interface Discount {
  discount_cost: number | null;
  discount_coach_cost: number | null;
  discount_from: Date | null;
  discount_to: Date | null;
}

export interface CostPair {
  group: number;
  cost: number;
}

export type VideoWithSchedule = {
  date: string;
  videoId: number;
};

export interface ProgramEditorValues {
  title: string;
  promo_image: string;
  promo_video: number;
  description: string;
  cost_base: number;
  periodicity: boolean;
  schedule: boolean;
  schedules: VideoWithSchedule[];
  module: number;
  tags: number[];
  excluded_videos_period: number[][];
  exercises: number[];
  // discount: Discount[];
  custom_groups?: number[];
  excluded_custom_groups?: number[];
  published?: boolean;
  favorite?: boolean;
  access_duration: number;
  costs: GroupCost[];
  costsEditor?: any[];
  with_comments: boolean;
  with_likes: boolean;
  partitions: number[];
}

export const programCreateSchema = yup.object().shape({
  title: yup.string().required('Укажите название видеопрограммы'),
  // cost_base: yup
  //   .number()
  //   .required('Укажите стоимость программы')
  //   .typeError('Укажите стоимость программы'),
  costs: yup.array().of(
    yup.object().shape({
      cost: yup.number().required(' ').typeError(' '),
      group: yup.mixed().required(' ').typeError(' '),
    })
  ),
  promo_image: yup.string().required('Загрузите обложку'),

  module: yup
    .number()
    .test('zero_is_valid', 'Выберите раздел', (value) => value !== 0 || value == null),
});

export const programUpdateSchema = yup.object().shape({
  title: yup
    .string()
    .required('Укажите название видеопрограммы')
    .min(3, 'Слишком короткое название'),
  promo_image: yup.string().required('Загрузите обложку'),
  // cost_base: yup
  //   .number()
  //   .required('Укажите стоимость программы')
  //   .typeError('Укажите стоимость программы'),
  module: yup
    .number()
    .test('zero_is_valid', 'Выберите раздел', (value) => value !== 0 || value == null),
});
